export const GET_ENTITY_PROFILES = 'entity-profiles/GET_ENTITY_PROFILES'
export const GET_ENTITY_PROFILE = 'entity-profiles/GET_ENTITY_PROFILE'
export const ADD_ENTITY_PROFILE = 'entity-profiles/ADD_ENTITY_PROFILES'
export const EDIT_ENTITY_PROFILE = 'entity-profiles/EDIT_ENTITY_PROFILES'
export const DELETE_ENTITY_PROFILES = 'entity-profiles/DELETE_ENTITY_PROFILES'
export const START_LOADING_ENTITY_PROFILES =
  'entity-profiles/START_LOADING_ENTITY_PROFILES'
export const STOP_LOADING_ENTITY_PROFILES =
  'entity-profiles/STOP_LOADING_ENTITY_PROFILES'
